module.exports = __webpack_public_path__ + "static/media/TAPE.9524c173.svg";